module.exports = __webpack_public_path__ + "static/media/2.ade88ce8.jpg";